export default "__VITE_ASSET__BsAtFHwd__"